import type { DrawData } from '@svenskaspelab/poolbetting/schema/draw';
import type { DateTime } from '@svenskaspelab/poolbetting/schema/frameworks';
import type { EventNumber } from '@svenskaspelab/poolbetting/schema/sport';

/**
 * Resolves match start time for a specific event in a draw.
 * Returns undefined when sportinfo data is missing for the event.
 *
 * @param drawData the draw data containing events and betting events
 * @param eventNumber the event number to find the match start time for
 * @returns the match start time as DateTime or undefined if not available
 */
export function getMatchStartTime(drawData: DrawData, eventNumber: EventNumber): DateTime | undefined {
  const drawEvent = drawData.draw.events.find((event) => event.eventNumber === eventNumber);
  if (!drawEvent || drawEvent.status !== 'COMPLETE') {
    return undefined;
  }

  return drawData.bettingEvent[drawEvent.bettingEventId]?.startDate;
}
